import { render, staticRenderFns } from "./LlTextButton.vue?vue&type=template&id=063fb2fe"
import script from "./LlTextButton.vue?vue&type=script&lang=js"
export * from "./LlTextButton.vue?vue&type=script&lang=js"
import style0 from "./LlTextButton.vue?vue&type=style&index=0&id=063fb2fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports